export const headerStyles = {
    position: { base: 'fixed', tablet: 'relative' },
    left: { base: '0', tablet: 'unset' },
    top: { base: '0', tablet: 'unset' },
    width: '100%',
    height: {
        base: '52px',
        tablet: '64px',
    },
    zIndex: { base: 'layer6', desktop: 'layer3' },
    textAlign: 'center',
    transition: 'left .2s cubic-bezier(.25,.46,.45,.94)',
    backgroundColor: 'white',
    paddingX: { base: 0, desktop: '20px' },
    boxSizing: 'border-box',
};
export const tallHeaderStyles = {
    ...headerStyles,
    height: {
        base: '52px',
        tablet: '84px',
    },
};
